// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Key } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconKey(props: any) {
    return <IconBase icon={Key} {...props} />
  }

  export default IconKey
  